import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { Outlet, Navigate, useLocation} from "react-router-dom";

export const ProtectedRoutes = props =>{
    const {isAuthorized, ...other} = props;

    const location = useLocation();
    const currentUser = useSelector(state => state.currentUser);

    if (!currentUser.IsAuthenticated)
        return <Navigate to="/login" replace={true} state={{from:{...location}}} />;
       
    const canAccess = isAuthorized(currentUser);
    if (canAccess)
        return <Outlet />
    else
        return <Navigate to="unauthorized" replace={true} />
};

ProtectedRoutes.propTypes = {
    isAuthorized: PropTypes.func
};

ProtectedRoutes.defaultProps = {
    isAuthorized: () => true
}